import { useEffect } from 'react';
import useSiteSettings from '../../hooks/useSiteSettings';

const SiteTheme = () => {
  const { settings } = useSiteSettings();

  useEffect(() => {
    const branding = settings?.branding;
    if (!branding) return;

    const root = document.documentElement;
    if (branding.primary_color) {
      root.style.setProperty('--brand-blue', branding.primary_color);
    }
    if (branding.primary_dark_color) {
      root.style.setProperty('--brand-blue-dark', branding.primary_dark_color);
    }
  }, [settings]);

  return null;
};

export default SiteTheme;
